import withConfigTransport from '../../services/config-transport/withConfigTransport'

import VaColorPaletteComponent from './VaColorPalette.vue'

export const VaColorPalette = withConfigTransport(VaColorPaletteComponent)
